<template>
  <div class="sustainability">
    <div class="decoration-element">
      <div class="decoration-element-2"></div>
    </div>
    <div class="row row-1">
      <div class="img-and-text img-and-text-sm">
        <img
          class="row-1-top-img"
          src="../../assets/img/sustainability/sustainability/sustainability.jpg"
        >
        <div class="text-group">
          <h3 class="text-accent">{{ $t('sustainability-1') }}</h3>
          <h1>{{ $t('sustainability-2') }}</h1>
          <h2 v-html="$t('sustainability-3-pre')"></h2>
          <h2>{{ $t('sustainability-3') }}</h2>
          <p>{{ $t('sustainability-3-1') }}</p>
          <h2 v-html="$t('sustainability-3-2')"></h2>
          <h2 v-html="$t('sustainability-3-3')"></h2>
          <h2 v-html="$t('sustainability-3-4')"></h2>
        </div>
      </div>
      <div class="img-and-btn">
        <Rotator v-if="chrome"/>
        <video v-else class="rotator-video-desktop" autoplay muted loop>
          <source src="../../assets/video/sustainability.mp4" type="video/mp4">Your browser does not support the video tag.
        </video>
        <!-- <div class="btn-arrow" @click="toggleScroll()">
          <span class="kcm toggle-down">C</span>
        </div> -->
      </div>
      <video class="rotator-video" autoplay muted loop>
        <source src="../../assets/video/sustainability.mp4" type="video/mp4">Your browser does not support the video tag.
      </video>
    </div>
    <div class="sustainability-showcase">
      <div class="row sustainability-showcase-row-1">
        <div class="img-preview img-preview-desktop"></div>
        <img
          class="img-preview-mobile"
          src="../../assets/img/sustainability/sustainability/gallery_1.jpg"
        >
        <div class="text-group-and-image">
          <div class="text-group">
            <h2>{{ $t('sustainability-4') }}</h2>
            <p>{{ $t('sustainability-5') }}</p>
            <router-link to="/sustainability?page=health-and-safety" class="link">
              <span class="text-main-home">{{ $t('learn-more') }}</span>
            </router-link>
          </div>
          <div class="img-preview-mini img-preview-mini-desktop"></div>
          <img
            class="img-preview-mini-mobile"
            src="../../assets/img/sustainability/sustainability/gallery_2.jpg"
          >
        </div>
      </div>
      <div class="row sustainability-showcase-row-2">
        <img
          class="img-preview-mobile"
          src="../../assets/img/sustainability/sustainability/gallery_3.jpg"
        >
        <div class="text-group-and-image">
          <div class="text-group">
            <h2>{{ $t('sustainability-6') }}</h2>
            <p>{{ $t('sustainability-7') }}</p>
            <router-link to="/sustainability?page=environment" class="link text-main-home">
              <span class="text-main-home">{{ $t('learn-more') }}</span>
            </router-link>
          </div>
          <div class="img-preview-mini img-preview-mini-desktop"></div>
          <img
            class="img-preview-mini-mobile"
            src="../../assets/img/sustainability/sustainability/gallery_4.jpg"
          >
        </div>
        <div class="img-preview img-preview-desktop"></div>
      </div>
      <div class="row sustainability-showcase-row-3">
        <div class="img-preview img-preview-desktop"></div>
        <img
          class="img-preview-mobile"
          src="../../assets/img/sustainability/sustainability/gallery_5.jpg"
        >
        <div class="text-group-and-image">
          <div class="text-group">
            <h2>{{ $t('sustainability-8') }}</h2>
            <p>{{ $t('sustainability-9') }}</p>
            <router-link
              to="/sustainability?page=social-responsibility"
              class="link text-main-home"
            >
              <span class="text-main-home">{{ $t('learn-more') }}</span>
            </router-link>
          </div>
          <div class="img-preview-mini img-preview-mini-desktop"></div>
        </div>
        <div class="img-preview img-preview-desktop"></div>
        <img
          class="img-preview-mobile"
          src="../../assets/img/sustainability/sustainability/gallery_7.jpg"
        >
      </div>
    </div>
  </div>
</template>

<script>
import Rotator from "./Rotator";
export default {
  components: {
    Rotator
  },
  data() {
    return {
      chrome: true
    };
  },
  methods: {
    toggleScroll() {
      const btn = document.getElementsByClassName("btn-arrow")[0];
      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;
      window.scrollTo({
        top: btn.getBoundingClientRect().bottom + scrollTop,
        behavior: "smooth"
      });
    }
  },
  mounted() {
    navigator.sayswho = (function() {
      var ua = navigator.userAgent,
        tem,
        M =
          ua.match(
            /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
          ) || [];
      if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return "IE " + (tem[1] || "");
      }
      if (M[1] === "Chrome") {
        tem = ua.match(/\b(OPR|Edge?)\/(\d+)/);
        if (tem != null)
          return tem
            .slice(1)
            .join(" ")
            .replace("OPR", "Opera")
            .replace("Edg ", "Edge ");
      }
      M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
      if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
      return M.join(" ");
    })();

    if (navigator.sayswho.indexOf("Chrome") != -1) {
      this.chrome = true;
    } else {
      this.chrome = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.sustainability {
  position: relative;
  .row-1 {
    padding-bottom: 0;
    .img-and-btn {
      .rotator-video-desktop {
        display: block;
      }
      .rotator-video-desktop,
      .sustainability-rotator {
        margin-left: 200px;
        width: calc(100% - 200px);
      }
    }
    .rotator-video {
      display: none;
    }
  }
  .sustainability-showcase {
    // margin-top: -10px;
    .sustainability-showcase-row-1,
    .sustainability-showcase-row-2,
    .sustainability-showcase-row-3 {
      @extend %flex-center;
      align-items: stretch;
      border: 10px solid #fff;
      .img-preview {
        @include transition(all 1s $mainCubic);
        background-image: url("../../assets/img/sustainability/sustainability/gallery_1.jpg");
        background-size: cover;
        background-position: center;
        display: block;
        height: 80vh;
        width: 65%;
      }
      .img-preview-mobile {
        display: none;
      }
      .text-group-and-image {
        @extend %flex-center;
        border-left: 10px solid #fff;
        border-right: 10px solid #fff;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        width: 35%;
        .text-group {
          @include transition(all 1s $mainCubic);
          @extend %flex-center;
          flex-direction: column;
          height: 70%;
          padding: 0 20px;
          width: 100%;
          h2,
          p,
          .link {
            text-align: center;
            @include transition(all 1s $mainCubic);
          }
          h2 {
            font-size: 26px;
            line-height: 26px;
            margin: 0;
            // IE
            width: 100%;
          }
          p {
            font-size: 18px;
            // IE
            width: 100%;
          }
        }
        .img-preview-mini {
          background-image: url("../../assets/img/sustainability/sustainability/gallery_2.jpg");
          background-size: cover;
          background-position: center;
          border-top: 10px solid #fff;
          height: 30%;
          display: block;
          width: 100%;
          @include transition(all 1s $mainCubic);
        }
        .img-preview-mini-mobile {
          display: none;
        }
      }
    }
    .sustainability-showcase-row-1 {
      .text-group-and-image {
        border-right: none;
      }
    }
    .sustainability-showcase-row-2 {
      border-top: none;
      .img-preview {
        background-image: url("../../assets/img/sustainability/sustainability/gallery_3.jpg");
      }
      .text-group-and-image {
        border-left: none;
        .img-preview-mini {
          background-image: url("../../assets/img/sustainability/sustainability/gallery_4.jpg");
        }
      }
    }
    .sustainability-showcase-row-3 {
      border-top: none;
      .img-preview {
        width: 35%;
      }
      .img-preview:first-child {
        background-image: url("../../assets/img/sustainability/sustainability/gallery_5.jpg");
      }
      .img-preview:last-child {
        background-image: url("../../assets/img/sustainability/sustainability/gallery_6.jpg");
      }
      .text-group-and-image {
        width: calc(30% + 29px);
        .text-group {
          position: relative;
        }
        .img-preview-mini {
          background-image: url("../../assets/img/sustainability/sustainability/gallery_7.jpg");
        }
      }
    }
    // TRIANGLES
    .sustainability-showcase-row-1 {
      .text-group-and-image::before {
        content: "";
        border-style: solid;
        border-width: 25px 30px 25px 0;
        border-color: transparent #ffffff transparent transparent;
        height: 0;
        left: -30px;
        position: absolute;
        top: 35%;
        transform: translateY(-50%);
        width: 0;
      }
      .text-group-and-image::after {
        content: "";
        border-style: solid;
        border-width: 12.5px 15px 12.5px 0;
        border-color: transparent $bgColor4 transparent transparent;
        height: 0;
        left: -15px;
        position: absolute;
        top: 35%;
        transform: translateY(-50%);
        @include transition(all 1s $mainCubic);
        width: 0;
      }
    }
    .sustainability-showcase-row-2 {
      .text-group-and-image::before {
        content: "";
        border-style: solid;
        border-width: 25px 0 25px 30px;
        border-color: transparent transparent transparent #fff;
        height: 0;
        right: -30px;
        position: absolute;
        top: 35%;
        transform: translateY(-50%);
        width: 0;
      }
      .text-group-and-image::after {
        content: "";
        border-style: solid;
        border-width: 12.5px 0 12.5px 15px;
        border-color: transparent transparent transparent $bgColor4;
        height: 0;
        right: -15px;
        position: absolute;
        top: 35%;
        transform: translateY(-50%);
        @include transition(all 1s $mainCubic);
        width: 0;
      }
    }
    .sustainability-showcase-row-3 {
      .text-group::before {
        content: "";
        border-style: solid;
        border-width: 30px 25px 0 25px;
        border-color: #fff transparent transparent transparent;
        height: 0;
        left: 50%;
        position: absolute;
        top: 100%;
        transform: translateX(-50%);
        width: 0;
      }
      .text-group::after {
        content: "";
        border-style: solid;
        border-width: 15px 12.5px 0 12.5px;
        border-color: $bgColor4 transparent transparent transparent;
        height: 0;
        left: 50%;
        position: absolute;
        top: 100%;
        transform: translateX(-50%);
        @include transition(all 1s $mainCubic);
        width: 0;
      }
    }
    // HOVER
    .sustainability-showcase-row-1:hover {
      .img-preview {
        background-image: url("../../assets/img/sustainability/sustainability/gallery_2.jpg");
      }
      .text-group-and-image {
        .text-group {
          background-color: #2aacef;
          h2,
          p {
            color: #fff;
          }
        }
        .img-preview-mini {
          background-image: url("../../assets/img/sustainability/sustainability/gallery_1.jpg");
          background-position: top;
        }
      }
      .text-group-and-image::after {
        border-color: transparent #2aacef transparent transparent;
      }
    }
    .sustainability-showcase-row-2:hover {
      .img-preview {
        background-image: url("../../assets/img/sustainability/sustainability/gallery_4.jpg");
      }
      .text-group-and-image {
        .text-group {
          background-color: #3c8d1e;
          h2,
          p {
            color: #fff;
          }
        }
        .img-preview-mini {
          background-image: url("../../assets/img/sustainability/sustainability/gallery_3.jpg");
        }
      }
      .text-group-and-image::after {
        border-color: transparent transparent transparent #3c8d1e;
      }
    }
    .sustainability-showcase-row-3:hover {
      .img-preview:first-child {
        background-image: url("../../assets/img/sustainability/sustainability/gallery_6.jpg");
      }
      .img-preview:last-child {
        background-image: url("../../assets/img/sustainability/sustainability/gallery_7.jpg");
      }
      .text-group-and-image {
        .text-group {
          background-color: #f58220;
          h2,
          p {
            color: #fff;
          }
        }
        .img-preview-mini {
          background-image: url("../../assets/img/sustainability/sustainability/gallery_5.jpg");
        }
      }
      .text-group::after {
        border-color: #f58220 transparent transparent transparent;
      }
    }
  }
}
@media screen and (max-width: 1440px) {
  .sustainability {
    .row-1 {
      padding-bottom: 0;
      .img-and-btn {
        .rotator-video-desktop,
        .sustainability-rotator {
          margin-left: 150px;
          width: calc(100% - 150px);
        }
      }
    }
    .sustainability-showcase {
      .sustainability-showcase-row-1,
      .sustainability-showcase-row-2,
      .sustainability-showcase-row-3 {
        .text-group-and-image {
          .text-group {
            h2 {
              font-size: 20px;
              line-height: 20px;
            }
            p {
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .sustainability {
    .row-1 {
      flex-direction: column;
      .img-and-text {
        width: 100%;
        .text-group {
          margin-bottom: 50px;
        }
        img {
          display: none;
        }
      }
      .img-and-btn {
        margin-bottom: 10px;
        padding: 0;
        width: 100%;
        .rotator-video-desktop,
        .sustainability-rotator {
          margin: 0;
          width: 100%;
        }
        .btn-arrow {
          display: none;
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .sustainability {
    .row-1 {
      flex-direction: column;
      padding: 0;
      .img-and-text {
        .text-group {
          margin: 0;

          padding: $sidesPadding1280;
        }
        img {
          display: none;
        }
      }
    }
    .sustainability-showcase {
      .sustainability-showcase-row-1,
      .sustainability-showcase-row-2,
      .sustainability-showcase-row-3 {
        border: none;
        border-top: 10px solid #fff;
        flex-direction: column;
        .img-preview-desktop {
          display: none;
        }
        .img-preview-mobile {
          border: none;
          display: block;
          height: 100%;
          width: 100%;
        }
        .text-group-and-image {
          border: none;
          margin: 0;
          width: 100%;
          .text-group {
            border: 10px solid #fff;
            padding: 20px;
            position: relative;
            h2 {
              font-size: 20px;
              line-height: 20px;
            }
            p {
              font-size: 14px;
            }
          }
          .text-group::before {
            content: "";
            border-style: solid;
            border-width: 30px 25px 0 25px;
            border-color: #fff transparent transparent transparent;
            height: 0;
            left: 50%;
            position: absolute;
            top: 100%;
            transform: translateX(-50%);
            width: 0;
          }
          .text-group::after {
            content: "";
            border-style: solid;
            border-width: 15px 12.5px 0 12.5px;
            border-color: $bgColor4 transparent transparent transparent;
            height: 0;
            left: 50%;
            position: absolute;
            top: 100%;
            transform: translateX(-50%);
            @include transition(all 1s $mainCubic);
            width: 0;
          }
          .img-preview-mini-desktop {
            display: none;
          }
          .img-preview-mini-mobile {
            border: none;
            display: block;
            height: auto;
            width: 100%;
          }
        }
        .text-group-and-image::before,
        .text-group-and-image::after {
          display: none;
        }
      }
      .sustainability-showcase-row-1 {
        .text-group-and-image {
          .text-group {
            background-color: #2aacef;
            h2,
            p {
              color: #fff;
            }
          }
          .text-group::after {
            border-color: #2aacef transparent transparent transparent;
          }
        }
      }
      .sustainability-showcase-row-2 {
        .text-group-and-image {
          .text-group {
            background-color: #3c8d1e;
            h2,
            p {
              color: #fff;
            }
          }
          .text-group::after {
            border-color: #3c8d1e transparent transparent transparent;
          }
        }
      }
      .sustainability-showcase-row-3 {
        .text-group-and-image {
          .text-group {
            background-color: #f58220;
            h2,
            p {
              color: #fff;
            }
          }
          .text-group::after {
            border-color: #f58220 transparent transparent transparent;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .sustainability {
    .row-1 {
      .img-and-text {
        .text-group {
          padding: $sidesPadding600;
        }
      }
      .img-and-btn {
        display: none;
      }
      .rotator-video {
        border-bottom: 10px solid #fff;
        display: block;
        height: auto;
        width: 100%;
      }
    }
  }
}
</style>
